import { Button } from "@mui/material";
import containerStyles from "utilities/styles/containerStyles.module.scss";
import styles from "features/slideShow/slideShow.module.scss";
import Spinner from "features/spinner/Spinner";
import { toast } from "react-toastify";
import { useDeleteMediaMutation } from "app/api/media";
import { Verification } from "models/Verification";
import { useChecklistContext } from "context/ChecklistContext";

type ConfirmDeleteModalProps = {
  currentVerification: Verification;
  setCurrentSlide: (slide: number) => void;
  handleSlideshowModalClose: () => void;
  onCloseModal: () => void;
};

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = (props) => {
  const { currentVerification, setCurrentSlide, handleSlideshowModalClose } = props;
  const { checklist } = useChecklistContext();
  const [deleteFile, { isLoading: fileIsLoading }] = useDeleteMediaMutation();

  const mediaType = currentVerification.type === 2 ? "filmen" : "bilden";

  const handleCloseModal = () => {
    props.onCloseModal(); // call the callback function passed down from parent
  };

  const handleDelete = () => {
    if (!currentVerification) return;
    deleteFile({ checklistId: checklist.id, mediaId: currentVerification.id })
      .unwrap()
      .then(() => {
        toast.success(`${mediaType} har raderats!`, {
          autoClose: 3000,
          hideProgressBar: true,
        });
        setCurrentSlide(0);
        handleCloseModal();
        handleSlideshowModalClose();
      })
      .catch(() => {
        toast.error(`Någonting gick fel när ${mediaType} skulle raderas.`, {
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
  };

  return (
    <>
      <div className={containerStyles.overlay}>
        <div className={styles.confirmDelete}>
          {fileIsLoading ? (
            <div className="d-flex flex-column align-items-center justify-content-center my-3">
              <Spinner size="3rem" color="#5f5f5f" className="mb-3" />
              <p className="text-dark">Raderar {mediaType}...</p>
            </div>
          ) : (
            <>
              <p className="fw-bold text-dark mb-3">
                Är du säker på att du vill radera {mediaType}?
              </p>
              <Button
                variant="contained"
                onClick={() => handleDelete()}
                className="me-2"
                color="error"
              >
                Radera
              </Button>

              <Button onClick={handleCloseModal} variant="contained">
                Behåll
              </Button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ConfirmDeleteModal;
